import * as React from 'react';
import { createSvgIcon } from '@fluentui/react-icons-mdl2';

const AdminMLogoInverse32Icon = createSvgIcon({
  svg: ({ classes }) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2048 2048" className={classes.svg}>
      <path d="M1405 1024q0 26-10 49t-27 40-39 27-49 10V899q26 0 48 10t40 27 27 40 10 48zm606 85l-63 236-207-27q-34 53-75 95l72 188-211 123-126-164q-62 14-121 14v-207q71 0 133-26t108-73 74-109 27-133q0-71-27-133t-73-108-109-74-133-27V472h5l78-177 236 63-26 201q54 35 98 80l184-71 123 211-164 126q13 58 13 122l184 82zM64 269L1216 64v1920L64 1785V269zm197 1124l113 9V988q0-48-1-96t-4-97l3-1q4 26 7 52t11 52l140 516 115 9 153-542q8-27 12-54t10-56h3q-2 45-3 88t-2 88v490l156 13V605l-223 18-132 477q-8 28-14 55t-11 57h-3q-6-56-21-112L447 648l-186 15v730z" />
    </svg>
  ),
  displayName: 'AdminMLogoInverse32Icon',
});

export default AdminMLogoInverse32Icon;
